import type { ComponentType } from "react";
import type { TicketLinkedEntityDto } from "@/api/tickets";
import { CallRecordLinkedEntity } from "./call-record-linked-entity";
import { GenericLinkedEntity } from "./generic-linked-entity";
import type { LinkedEntityRendererProps } from "./linked-entity-card";

// 新数据源在这里注册展示组件，工单列表与后端提供者不需要知道它的 UI 布局。
const renderers = new Map<string, ComponentType<LinkedEntityRendererProps>>([["call_center/call_record", CallRecordLinkedEntity]]);

export function getLinkedEntityRenderer(link: TicketLinkedEntityDto) {
  return renderers.get(`${link.systemCode.toLowerCase()}/${link.entityType.toLowerCase()}`) ?? GenericLinkedEntity;
}
